import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import { navModule } from './modules/nav';

// import { gitlabAuthApiRef} from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { homeModule } from './modules/home';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          providers={['guest']}
          // Uncomment to enable login Gitlab UI
          // provider={{
          //   id: 'gitlab-auth-provider',
          //   title: 'Gitlab Authentication',
          //   message: 'Login with your Gitlab Maxsol account',
          //   apiRef: gitlabAuthApiRef,
          // }}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    catalogGraphPlugin,
    navModule,
    homeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
